import { useEffect, useState } from "react";

// ASSETS
import FirePhoto from "assets/img/FirePhoto.jpg";
import CareerIcon from "assets/svg/CareerIcon.svg";
import AboutImg from "assets/img/despre/AboutImg.jpg";
import AboutImg2 from "assets/img/despre/AboutImg2.jpg";
import AboutImg3 from "assets/img/despre/AboutImg3.jpg";
import AboutImg4 from "assets/img/despre/AboutImg4.jpg";
import AboutImg5 from "assets/img/despre/AboutImg5.jpg";
import AboutImg6 from "assets/img/despre/AboutImg6.jpg";
import AboutImg7 from "assets/img/despre/AboutImg7.jpg";
import AboutImg1vrt from "assets/img/despre/AboutImg1vrt.jpg";
import AboutImg2vrt from "assets/img/despre/AboutImg2vrt.jpg";
import AboutImg3vrt from "assets/img/despre/AboutImg3vrt.jpg";
import AboutImg1orz from "assets/img/despre/AboutImg1orz.jpg";
import AboutImg2orz from "assets/img/despre/AboutImg2orz.jpg";

// STYLES
import {
  CardImage,
  CardImageWrapper,
  CardTextWrapper,
  CardsSectionContainer,
  CardsSectionContentWrapper,
  CareerCardImage,
  CareerCardImageWrapper,
  CareerCardTextWrapper,
  CirclesWrapper,
  EighthCardWrapper,
  FifthCardWrapper,
  FirstCardTextWrapper,
  FirstCardTitleWrapper,
  FirstCardWrapper,
  FourthCardWrapper,
  HorizontalWrapper,
  LimitedWidthContainer,
  NinthCardWrapper,
  NinthHorizontalWrapper,
  SecondCardWrapper,
  SeventhCardWrapper,
  SixthCardWrapper,
  ThirdCardWrapper,
  VerticalWrapper,
} from "./CardsSectionStyled";

// LIBRARIES
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// MISC
import { COLORS } from "constants/variables";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { ImageType } from "./CardsSectionModel";
import aboutService from "services/aboutService";
import { selectLanguage } from "slices/LanguageSlice/languageSlice";

// REDUX

// COMPONENTS
import CirclesAtom from "components/Atoms/CirclesAtom/CirclesAtom";
import CustomText from "components/Atoms/CustomText/CustomText";

const CardsSection = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { t } = useTranslation();
  const language = useSelector(selectLanguage);

  // STATE CONSTANTS
  const [attribution, setAttribution] = useState<any>();
  const colors = {
    firstColor: COLORS.Background + "29",
    secondColor: COLORS.VividAuburn,
  };

  const sizes = ["400px", "325px", "250px", "175px", "100px"];

  // API REQUESTS
  useEffect(() => {
    aboutService
      .getAttribution()
      .then((response) => {
        setAttribution(response);
      })
      .catch((err) => {
        console.log("getAttribution error", err);
      });
  }, [language]);

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const navigateToCareer = () => {
    // TODO: Navigate to career page
  };

  return (
    <CardsSectionContainer>
      <LimitedWidthContainer>
        {!isMobile && (
          <>
            <CirclesWrapper>
              <CirclesAtom
                sizes={sizes}
                colors={colors}
                containerTopPosition="25px"
                containerRightPosition="25px"
              />
            </CirclesWrapper>
            <CirclesWrapper>
              <CirclesAtom
                sizes={sizes}
                colors={colors}
                containerTopPosition="50%"
                containerLeftPosition="0%"
              />
            </CirclesWrapper>
          </>
        )}
        <CardsSectionContentWrapper>
          <FirstCardWrapper>
            <FirstCardTitleWrapper>
              <CustomText
                text={t("view.about.aboutDSU.attributionsSection.attributions")}
                type={TextType.H3}
                color={COLORS.Cultured}
              />
              <CustomText
                text={t("view.about.aboutDSU.attributionsSection.DSU")}
                type={TextType.H3}
                color={COLORS.Yellow}
              />
            </FirstCardTitleWrapper>
            <FirstCardTextWrapper>
              <CustomText
                text={attribution?.data?.attributes?.paragraph_1}
                type={TextType.P1}
                color={COLORS.Background}
              />
            </FirstCardTextWrapper>
          </FirstCardWrapper>
          <SecondCardWrapper>
            <HorizontalWrapper>
              <CardImageWrapper type={ImageType.SQUARE_SMALL}>
                <CardImage src={AboutImg} alt="FirePhoto" />
              </CardImageWrapper>
              <CardImageWrapper type={ImageType.SQUARE_SMALL}>
                <CardImage src={AboutImg2} alt="FirePhoto" />
              </CardImageWrapper>
            </HorizontalWrapper>
            <CardTextWrapper>
              <CustomText
                text={attribution?.data?.attributes?.quote}
                color={COLORS.Yellow}
                type={TextType.H3}
              />
            </CardTextWrapper>
          </SecondCardWrapper>
          <ThirdCardWrapper>
            <VerticalWrapper>
              <CardImageWrapper type={ImageType.SQUARE_SMALL}>
                <CardImage src={AboutImg7} alt="FirePhoto" />
              </CardImageWrapper>
              <CardImageWrapper type={ImageType.SQUARE_SMALL}>
                <CardImage src={AboutImg1vrt} alt="FirePhoto" />
              </CardImageWrapper>
            </VerticalWrapper>
            <VerticalWrapper>
              <CardImageWrapper type={ImageType.RECTANGULAR_TALL}>
                <CardImage src={AboutImg2vrt} alt="FirePhoto" />
              </CardImageWrapper>
            </VerticalWrapper>
          </ThirdCardWrapper>
          <FourthCardWrapper>
            <HorizontalWrapper>
              <CardImageWrapper type={ImageType.RECTANGULAR_LONG}>
                <CardImage src={AboutImg1orz} alt="FirePhoto" />
              </CardImageWrapper>
            </HorizontalWrapper>
            <HorizontalWrapper>
              <CardImageWrapper type={ImageType.SQUARE_SMALL}>
                <CardImage src={AboutImg3} alt="FirePhoto" />
              </CardImageWrapper>
              <CardImageWrapper type={ImageType.SQUARE_SMALL}>
                <CardImage src={AboutImg4} alt="FirePhoto" />
              </CardImageWrapper>
            </HorizontalWrapper>
          </FourthCardWrapper>
          <FifthCardWrapper>
            <CustomText
              text={attribution?.data?.attributes?.paragraph_2}
              type={TextType.P1}
              color={COLORS.Background}
            />
          </FifthCardWrapper>
          <SixthCardWrapper>
            <CustomText
              text={attribution?.data?.attributes?.paragraph_3}
              type={TextType.P1}
              color={COLORS.Background}
            />
          </SixthCardWrapper>
          <SeventhCardWrapper>
            <HorizontalWrapper>
              <CareerCardTextWrapper
                href="https://hub.mai.gov.ro/recrutarecandidat/anunt/index"
                target="_blank"
                rel="noopener noreferrer"
              >
                <CustomText
                  text={t("view.about.aboutDSU.attributionsSection.career")}
                  type={TextType.H3}
                  color={COLORS.RaisinBlack}
                />
                <CustomText
                  text={t("view.about.aboutDSU.attributionsSection.DSU")}
                  type={TextType.H3}
                  color={COLORS.VividAuburn}
                />
                <CustomText
                  text={t("view.emergencyCommunication.access")}
                  type={TextType.H5}
                  color={COLORS.RaisinBlack}
                />
              </CareerCardTextWrapper>
              <CareerCardImageWrapper onClick={navigateToCareer}>
                <CareerCardImage src={CareerIcon} />
              </CareerCardImageWrapper>
            </HorizontalWrapper>
          </SeventhCardWrapper>
          <EighthCardWrapper>
            <NinthHorizontalWrapper>
              <CardImageWrapper type={ImageType.RECTANGULAR_LONG}>
                <CardImage src={AboutImg2orz} alt="FirePhoto" />
              </CardImageWrapper>
            </NinthHorizontalWrapper>
          </EighthCardWrapper>
          <NinthCardWrapper>
            <NinthHorizontalWrapper>
              <CardImageWrapper type={ImageType.SQUARE_SMALL}>
                <CardImage src={AboutImg5} alt="FirePhoto" />
              </CardImageWrapper>
              <CardImageWrapper type={ImageType.SQUARE_SMALL}>
                <CardImage src={AboutImg6} alt="FirePhoto" />
              </CardImageWrapper>
            </NinthHorizontalWrapper>
          </NinthCardWrapper>
        </CardsSectionContentWrapper>
      </LimitedWidthContainer>
    </CardsSectionContainer>
  );
};

export default CardsSection;
